import React, { useState } from "react";

const BlurImage = ({ src, alt = "", className = "", ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <img
      src={src}
      alt={alt}
      onLoad={() => setIsLoaded(true)}
      className={`transition-all duration-500 ease-in-out rounded-md ${
        isLoaded ? "blur-0 opacity-100" : "blur-md opacity-70"
      } ${className}`}
      {...props}
    />
  );
};

export default BlurImage;
